import React from 'react'
import { PlaceholderPanel } from '../../style'

/** Simple centred placeholder used for tab panels whose content lands in a later ticket. */
export const PlaceholderTab: React.FC<{ message: string }> = ({ message }) => (
  <PlaceholderPanel>{message}</PlaceholderPanel>
)
